import { Modal, ModalProps, Typography } from 'antd';
import { useAppTranslation } from '../../../i18n/hooks';

type AccessCodeModalProps = Pick<ModalProps, 'open' | 'onClose' | 'onOk'>;

export const GetReferralCodeModal = ({ open, onClose }: AccessCodeModalProps) => {
  const { t } = useAppTranslation('common');

  return (
    <Modal
      className="position-tab-modal"
      centered
      title={t('getReferralCodeModal.title')}
      open={open}
      footer={false}
      onClose={onClose}
      onCancel={onClose}
      styles={{
        mask: {
          backgroundImage: "url('/images/dex-bg.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        },
        wrapper: {
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          zIndex: 2147483648,
        },
      }}
    >
      <div>
        <Typography.Paragraph>
          <b>{t('getReferralCodeModal.betaMessage')}</b>
          <br />
          {t('getReferralCodeModal.askForCodeBefore')}{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://discord.com/invite/vdex-trade">
            Discord
          </a>{' '}
          {t('getReferralCodeModal.askForCodeAfter')}
        </Typography.Paragraph>
        <div className="flex justify-end mt-[10px] ">
          <a
            href="https://discord.com/invite/vdex-trade" // Replace with your actual link
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#1890ff] px-4 py-2 rounded hover:bg-[#e6f7ff] border border-[#1890ff] transition"
          >
            {t('getReferralCodeModal.joinDiscord')}
          </a>
        </div>
      </div>
    </Modal>
  );
};
